import { RouterModule, Routes } from '@angular/router';
import { AuthguardGuard } from 'src/app/onelog/common/auth/authguard.guard';
import { AccountsMasterComponent } from './accounts-master/accounts-master.component';
import { AuthorAdvancesInvoiceGeneratedComponent } from './author-advances-invoice-generated/author-advances-invoice-generated.component';
import { AuthorBookInformationComponent } from 'src/app/onelog/views/reports/author-book-information/author-book-information.component';
import { AuthorEmailIdComponent } from 'src/app/onelog/views/reports/author-email-id/author-email-id.component';
import { BankAuthorsComponent } from 'src/app/onelog/views/reports/bank-authors/bank-authors.component';
import { DerivativeSourceProductComponent } from './derivative-source-product/derivative-source-product.component';
import { DevFdPendingAcceptanceComponent } from 'src/app/onelog/views/reports/dev-fd-pending-acceptance/dev-fd-pending-acceptance.component';
import { DevMyTitleComponent } from './dev-my-title/dev-my-title.component';
import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';
import { FinanceAdvanceComponent } from './finance-advance/finance-advance.component';
import { FinanceRoyaltyRatesV1Component } from 'src/app/onelog/views/reports/finance-royalty-rates-v1/finance-royalty-rates-v1.component';
import { FinanceRoyaltyRatesV2Component } from 'src/app/onelog/views/reports/finance-royalty-rates-v2/finance-royalty-rates-v2.component';
import { OsdLogComponent } from 'src/app/onelog/views/reports/osd-log/osd-log.component';
import { PipelineInfoComponent } from './pipeline-info/pipeline-info.component';
import { PpdDumpComponent } from './ppd-dump/ppd-dump.component';
import { PublishedReportPageComponent } from './published-report/published-report-page.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { TotalRoyaltyProductComponent } from './total-royalty-product/total-royalty-product.component';
import { VideoLicensingPageComponent } from './video-licensing-page/video-licensing-page.component';
import { TitlesPublishedComponent } from './titles-published/titles-published.component';
import { TitlesInProductionComponent } from './titles-in-production/titles-in-production.component';
import { ChapterwiseTitlesInProductionComponent } from './chapterwise-titles-in-production/chapterwise-titles-in-production.component';
import { AccountsMasterNewComponent } from './accounts-master-new/accounts-master-new.component';
import { PpdDumpNewComponent } from './ppd-dump-new/ppd-dump-new.component';
import { AuthorBookInformationNewComponent } from './author-book-information-new/author-book-information-new.component';
import { OsdLogNewComponent } from './osd-log-new/osd-log-new.component';
import { accessCheck } from '../../common/auth/access.guard';
import { authCheck } from '../../common/auth/auth.guard';
import { NgModule } from '@angular/core';
import { AuthorInformationComponent } from './author-information/author-information.component';
import { AnnouncedContractedComponent } from './announced-contracted/announced-contracted.component';
import { TradeSaleComponent } from './trade-sale/trade-sale.component';
import { SourceDerivativeProductComponent } from './source-derivative-product/source-derivative-product.component';

const reportRoutes: Routes = [
  {
    path: 'report',
    children: [
      {
        path: 'published-reports',
        component: PublishedReportPageComponent,
        canActivate: [authCheck],
      },
      {
        path: 'video-licensing-products',
        component: VideoLicensingPageComponent,
        canActivate: [authCheck],
      },
      {
        path: 'dev-my-title',
        component: DevMyTitleComponent,
        canActivate: [authCheck],
      },
      {
        path: 'osd-log',
        component: OsdLogComponent,
        canActivate: [authCheck],
      },
      {
        path: 'ppd-dump',
        component: PpdDumpComponent,
        canActivate: [authCheck],
      },
      {
        path: 'finance-royalty-rates-v1',
        component: FinanceRoyaltyRatesV1Component,
        canActivate: [authCheck],
      },
      {
        path: 'contract-bank-authors',
        component: BankAuthorsComponent,
        canActivate: [authCheck],
      },
      {
        path: 'author-book-information',
        component: AuthorBookInformationComponent,
        canActivate: [authCheck],
      },
      {
        path: 'contract-bank-authors',
        component: BankAuthorsComponent,
        canActivate: [authCheck],
      },
      {
        path: 'derivative-source-product',
        component: DerivativeSourceProductComponent,
        canActivate: [authCheck],
      },
      {
        path: 'finance-advances',
        component: FinanceAdvanceComponent,
        canActivate: [authCheck],
      },
      {
        path: 'total-royalty-product',
        component: TotalRoyaltyProductComponent,
        canActivate: [authCheck],
      },
      {
        path: 'finance-royalty-rates-v2',
        component: FinanceRoyaltyRatesV2Component,
        canActivate: [authCheck],
      },
      {
        path: 'accounts-master',
        component: AccountsMasterComponent,
        canActivate: [authCheck],
      },
      {
        path: 'exchange-rates',
        component: ExchangeRatesComponent,
        canActivate: [authCheck],
      },
      {
        path: 'timesheet',
        component: TimesheetComponent,
        canActivate: [authCheck],
      },
      {
        path: 'pipeline-info',
        component: PipelineInfoComponent,
        canActivate: [authCheck],
      },
      {
        path: 'author-advance-invoice-generate',
        component: AuthorAdvancesInvoiceGeneratedComponent,
        canActivate: [authCheck],
      },
      {
        path: 'authors-emailid',
        component: AuthorEmailIdComponent,
        canActivate: [authCheck],
      },
      {
        path: 'dev-fd-pending-acceptance',
        component: DevFdPendingAcceptanceComponent,
        canActivate: [authCheck],
      },
      {
        path: 'dev-fd-pending-acceptance',
        component: DevFdPendingAcceptanceComponent,
        canActivate: [authCheck],
      },
      {
        path: 'titles-published',
        component: TitlesPublishedComponent,
        canActivate: [authCheck],
      },
      {
        path: 'titles-in-production',
        component: TitlesInProductionComponent,
        canActivate: [authCheck],
      },
      {
        path: 'chapterwise-titles-production',
        component: ChapterwiseTitlesInProductionComponent,
        canActivate: [authCheck],
      },
      {
        path: 'accounts-master-new',
        component: AccountsMasterNewComponent,
        canActivate: [authCheck],
      },
      {
        path: 'ppd-dump-new',
        component: PpdDumpNewComponent,
        canActivate: [authCheck],
      },
      {
        path: 'author-book-info-new',
        component: AuthorBookInformationNewComponent,
        canActivate: [authCheck],
      },
      {
        path: 'osd-log-new',
        component: OsdLogNewComponent,
        canActivate: [authCheck],
      },
      {
        path: 'author-information',
        component: AuthorInformationComponent,
        canActivate: [authCheck],
      },
      {
        path: 'announced-contracted',
        component: AnnouncedContractedComponent,
        canActivate: [authCheck],
      },
      {
        path: 'trade-sale',
        component: TradeSaleComponent,
        canActivate: [authCheck],
      },
      {
        path: 'source-derivative-product-rel',
        component: SourceDerivativeProductComponent,
        canActivate: [authCheck],
      }
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportRoutes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
